<template>
    <sys-teacher-hub-modal
        :show="show"
        @update:show="$emit('update:show', $event)"
        :title="title"
        icon="mdi-calendar-clock-outline"
    >
        <v-card-text class="pa-0">
            <div v-if="loading" class="pa-8 text-center">
                <v-progress-circular indeterminate color="primary" size="48" />
                <p class="mt-4 mb-0 text-body-1 grey--text">
                    Carregando disponibilidade...
                </p>
            </div>

            <v-alert
                v-else-if="error"
                dense
                outlined
                type="error"
                class="ma-4"
            >
                {{ error }}
            </v-alert>

            <div v-else>
                <v-tabs v-model="tab" grow>
                    <v-tab>
                        <v-icon left small>mdi-calendar-week</v-icon>
                        Semanal
                    </v-tab>
                    <v-tab :disabled="!canShowDateAvailability">
                        <v-icon left small>mdi-calendar-month-outline</v-icon>
                        Por data
                    </v-tab>
                </v-tabs>

                <v-divider />

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <sys-teacher-availability-week
                            :teacher-id="teacherId"
                            :work-time-id="workTimeId"
                            :release="false"
                            :text="teacherAvailabilityText"
                        />
                    </v-tab-item>

                    <v-tab-item>
                        <div v-if="canShowDateAvailability" class="pa-2">
                            <sys-teacher-availability-date
                                :release="false"
                                :teacher="teacher"
                                :token="token"
                                :work-time="workTime"
                                :colors="colors"
                                :text="teacherAvailabilityDateText"
                                @onComplete="handleOnComplete"
                            />
                        </div>
                        <v-alert
                            v-else
                            dense
                            outlined
                            type="info"
                            class="ma-4"
                        >
                            Disponibilidade por data não está habilitada para o período selecionado.
                        </v-alert>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-card-text>
    </sys-teacher-hub-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysTeacherAvailabilityHub',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        teacherId: {
            type: Number,
            required: true
        },
        workTimeId: {
            type: Number,
            required: true
        },
        token: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: 'Disponibilidade'
        }
    },
    data: () => ({
        loading: false,
        tab: 0,
        error: '',
        teacher: null,
        workTime: null,
        colors: ['error', 'success', 'orange', 'blue', 'grey', 'purple']
    }),
    computed: {
        canShowDateAvailability() {
            return !!(this.workTime && this.workTime.show_availability_date && this.teacher && this.teacher.availabilities && this.teacher.availabilities.length > 0)
        },
        teacherAvailabilityText() {
            return this.teacher?.realInstitution?.text_availability || null
        },
        teacherAvailabilityDateText() {
            return this.teacher?.realInstitution?.text_availability_date || null
        }
    },
    watch: {
        show(value) {
            if (value) this.loadContext()
        }
    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeacher', 'ActionFindTeacherByToken']),
        ...mapActions('worktime', ['ActionShowWorkTime']),
        async loadContext() {
            this.loading = true
            this.error = ''

            try {
                const workTimeResponse = await this.ActionShowWorkTime({
                    id: this.workTimeId,
                    with: 'term'
                })

                this.workTime = workTimeResponse.data

                const withRelations = 'institution.termOptions,institution.hourGroups,emails,contracts.position,availability.availabilities,campuses'

                const filters = [
                    {
                        name: 'confirmation',
                        key: 'work_time_id',
                        value: this.workTimeId
                    },
                    {
                        name: 'availability',
                        key: 'work_time_id',
                        value: this.workTimeId
                    }
                ]

                const teacherResponse = this.token
                    ? await this.ActionFindTeacherByToken({
                        token: this.token,
                        with: withRelations,
                        withContract: true,
                        filter_relation_withs: filters
                    })
                    : await this.ActionFindTeacher({
                        id: this.teacherId,
                        with: withRelations,
                        withContract: true,
                        filter_relation_withs: filters
                    })

                this.teacher = teacherResponse.data
            } catch (e) {
                this.error = 'Não foi possível carregar os dados de disponibilidade.'
            } finally {
                this.loading = false
            }
        },
        handleOnComplete(event) {
            if (!event || !event.text) return
            this.$emit('onComplete', event)
        }
    }
}
</script>
